import Vue from 'vue'; 

declare let $;
declare let window;

interface IFlyoutState {
    id: string;
    title: string;
    trigger: Partial<HTMLElement>;
}

const state: IFlyoutState = Vue.observable({
    id: '', 
    title: '',
    trigger: {} // node
});

//mutations
const setId = (newId: string): void => {
    state.id = newId; 
};
const setTitle = (newTitle: string): void => {
    state.title = newTitle; 
};
const setTrigger = (newTrigger: Partial<HTMLElement>): void => {
    state.trigger = newTrigger; 
};

// actions
const toggleFlyout = (id: string, trigger: Partial<HTMLElement>, title: string): void => { 
    // check to see if this flyout is the one that's
    // currently open. If it is, close it.
    if (id === state.id) {
        hideFlyout(); 
        return;
    }

    // make sure this executes after the clickaway event handler
    // to prevent immediately triggering the hideflyout method. 
    window.requestAnimationFrame(() => {
        showFlyout(id, trigger, title);
    });
    
};

const hideFlyout = (): void => { 
    setId('');
    setTitle('');
    setTrigger(null);

    _removeEventListeners();
};

const showFlyout = (id: string, trigger: Partial<HTMLElement>, title: string): void => { 
    setId(id);
    setTrigger(trigger);
    setTitle(title);

    _addEventListeners();
};

const _addEventListeners = (): void => { 
    // hide flyout on window resize
    $(window).one('resize.flyout', hideFlyout);
};

const _removeEventListeners = (): void => { 
    // remove listener to hide flyout on window resize
    $(window).off('resize.flyout', hideFlyout);
};

// Getters
const isShowing = (): boolean => {
    return state.id !== '';
};
const isActive = (id: string): boolean => { 
    return state.id === id;
};

const useFlyout = () => { 
    return {
        state,
        isActive,
        isShowing,
        hideFlyout,
        toggleFlyout
    };
};

export {useFlyout};
